NtechApp.TouchClickEvent = function(allowGhostClick) {
    var me = this;
    this._allowGhostClick = allowGhostClick || false;

    this._css = {
        ids: {},
        classes: {}
    }

    this._construct = function () {
        me._bindEvents();
    }

    this._bindEvents = function () {
    }

    this._unbindEvents = function () {
        ;
    }

    this.destruct = function () {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

// Deprecated with FastClick and browsers fix.
// @todo -> Remove this param from Autocomplete.js
NtechApp.TouchClickEvent.ALLOW_GHOST_CLICK = true;

// @todo -> Add namespaces to event names -> touchstart.touchclickev + index, ...
NtechApp.TouchClickEvent.prototype.listen = function($element, maybeListenElementChild, callbackFn) {
    var me = this;

    if(typeof maybeListenElementChild == "function") {
        var $elementChild = null;
        callbackFn = maybeListenElementChild;
    }
    else {
        var $elementChild = maybeListenElementChild;
    }

    $element.on("click", $elementChild, function(event) {
        callbackFn(event);
    });
};

// @todo Bug -> add namespaces to events
NtechApp.TouchClickEvent.prototype.unlisten = function($element) {
    $element.off("touchstart");
    $element.off("touchend");
    $element.off("click");
};